import { RecordingPreference } from '@api/generated/graphql';

export enum RecordingStatus {
  STARTED = 'STARTED',
  NOT_STARTED = 'NOT_STARTED',
  PAUSED = 'PAUSED',
}

export type RecordingState = {
  status: RecordingStatus;
  disabled: boolean;
};

export const defaultRecordingState: RecordingState = {
  status: RecordingStatus.NOT_STARTED,
  disabled: true,
};

// in some near future we will add the ALWAYS recording preference
// this should result in a recording state of STARTED and disabled: true

const getInitialRecordingState = (
  queueRecordingPreference: RecordingPreference | undefined,
  userRecordingPreference: RecordingPreference | undefined,
): RecordingState => {
  if (queueRecordingPreference === RecordingPreference.Automatic) {
    return {
      status: RecordingStatus.STARTED,
      disabled: false,
    };
  } else if (queueRecordingPreference === RecordingPreference.Never) {
    return {
      status: RecordingStatus.NOT_STARTED,
      disabled: true,
    };
  }

  // queueRecordingPreference is MANUAL or undefined, use userRecordingPreference

  if (userRecordingPreference === RecordingPreference.Automatic) {
    return {
      status: RecordingStatus.STARTED,
      disabled: false,
    };
  } else if (userRecordingPreference === RecordingPreference.Manual) {
    return {
      status: RecordingStatus.NOT_STARTED,
      disabled: false,
    };
  } else if (userRecordingPreference === RecordingPreference.Never) {
    return {
      status: RecordingStatus.NOT_STARTED,
      disabled: true,
    };
  }

  return defaultRecordingState;
};

export default getInitialRecordingState;
